import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Remove any platform-injected text/elements outside #root
(function cleanup() {
  const body = document.body;
  if (!body) return;
  const remove = () => {
    Array.from(body.childNodes).forEach(node => {
      if (node.nodeType === 1 && (node.id === 'root' || node.tagName === 'SCRIPT' || node.tagName === 'NOSCRIPT')) return;
      if (node.nodeType === 3 && node.textContent.trim()) node.remove();
      else if (node.nodeType === 1) node.remove();
    });
  };
  remove();
  new MutationObserver(remove).observe(body, { childList: true });
})();
